// 翻訳アプリ(Langwill)のフローティングセレクタをヘッダー内埋め込みへ切り替える（LAB-154）
// アプリ本体(floating-selector.js, defer)が #shop_metaFields_v2 の設定JSONを読む前に
// 書き換える必要があるため、theme.liquid の content_for_header より前で defer 読み込みする
(function () {
  var tag = document.getElementById('shop_metaFields_v2');
  if (!tag) return;
  try {
    var conf = JSON.parse(tag.textContent);
    ['desktop', 'mobile'].forEach(function (device) {
      var isStr = typeof conf[device] === 'string';
      var d = isStr ? JSON.parse(conf[device]) : conf[device];
      d.content.choose_language_selector = 'embedded_selector';
      d.content.embed_place = device === 'mobile' ? '#lang-switcher-sp' : '#lang-switcher-pc';
      d.content.embed_place_index = 0;
      // 言語表記はコード（Ja）。デザインの「Ja / JPY(¥)」に合わせる
      // バーと開いたパネル内の現在値で参照キーが入れ替わるため両方指定
      d.content.bar_labels_type = 'language_code';
      d.content.labels_type = 'language_code';
      conf[device] = isStr ? JSON.stringify(d) : d;
    });
    tag.textContent = JSON.stringify(conf);
  } catch (err) {
    // 設定が読めない場合はアプリ既定（フローティング表示）のまま動かす
  }
  // PCヘッダーの .header-right は mix-blend-mode: difference のレイヤーで、
  // 内側に開くパネルまで下地と差分合成されて読みにくくなる。
  // バーのクリック時にパネルだけをブレンド外の受け皿(.lang-panel-host)へ移し、
  // バー直下に位置合わせして不透明に描く。アプリJSは要素参照で開閉するため移動後も動く
  document.addEventListener(
    'click',
    function (e) {
      var bar = e.target.closest('#lang-switcher-pc .etranslate-selector-list-button');
      if (!bar) return;
      var host = document.getElementById('lang-panel-host');
      if (!host) return;
      var panel =
        document.querySelector('#lang-switcher-pc .etranslate-selector-list-dropdown') ||
        host.querySelector('.etranslate-selector-list-dropdown');
      if (!panel) return;
      if (panel.parentElement !== host) host.appendChild(panel);
      // barとhostのrect差分で計算する（viewport絶対値だと横スクロール時にズレる）
      var barRect = bar.getBoundingClientRect();
      var hostRect = host.getBoundingClientRect();
      panel.style.position = 'absolute';
      panel.style.left = 'auto';
      panel.style.right = hostRect.right - barRect.right + 'px';
      panel.style.top = barRect.bottom - hostRect.top + 8 + 'px';
    },
    true
  );
})();
